import * as React from "react";
import moment from "moment";
import { trimWithEllipsis } from "../../../utils/typography";
import {
  Container,
  ID,
  Summary,
  Description,
  Opened,
} from "./IssueListItem.styles";

interface Props {
  issue: Insite.API.Action;
  isSelected: boolean;
  onSelect(): void;
}

export const IssueListItem: React.FunctionComponent<Props> = ({
  issue,
  onSelect,
  isSelected,
}) => (
  <Container onClick={onSelect} isSelected={isSelected}>
    <ID>
      <strong>{issue.key}</strong> Updated{" "}
      {moment(issue.updated).format("DD/MM/YY")}
    </ID>
    <Summary>{issue.summary}</Summary>
    <Description>{trimWithEllipsis(issue.description)}</Description>
    <Opened>{moment(issue.created).fromNow()}</Opened>
  </Container>
);
